// On image-box click, hide image and play the video
$(document).on('click', 'section.clVideo .image-box', function() {
  let $b = $(this).closest('.body'), v = $b.find('video').get(0);
  $b.find('.image-box').hide(); // hide image
  v?.play(); // play video if exists
});

// Handle video play/pause to toggle image visibility
$('section.clVideo video').on('play pause', function(e) {
  $(this).closest('.body')
    .find('.image-box')
    .css('display', e.type === 'play' ? 'none' : ''); // hide on play, show on pause
});

